import pick from 'lodash/pick';
import { IPaginationBaseState, ISortBaseState } from 'react-jhipster';

/**
 * Removes fields with an 'id' field that equals ''.
 * This function was created to prevent entities to be sent to
 * the server with an empty id and thus resulting in a 500.
 *
 * @param entity Object to clean.
 */
export const cleanEntity = entity => {
  const keysToKeep = Object.keys(entity).filter(k => !(entity[k] instanceof Object) || (entity[k].id !== '' && entity[k].id !== -1));

  return pick(entity, keysToKeep);
};

/**
 * Simply map a list of element to a list a object with the element as id.
 *
 * @param idList Elements to map.
 * @returns The list of objects with mapped ids.
 */
export const mapIdList = (idList: ReadonlyArray<any>) => idList?.filter((id: any) => id !== '').map((id: any) => ({ id }));

export const overrideSortStateWithQueryParams = (paginationBaseState: ISortBaseState, locationSearch: string) => {
  const params = new URLSearchParams(locationSearch);
  const sort = params.get('sort');
  if (sort) {
    const sortSplit = sort.split(',');
    paginationBaseState.sort = sortSplit[0];
    paginationBaseState.order = sortSplit[1];
  }
  return paginationBaseState;
};

export const overridePaginationStateWithQueryParams = (paginationBaseState: IPaginationBaseState, locationSearch: string) => {
  const sortedPaginationState: IPaginationBaseState = <IPaginationBaseState>(
    overrideSortStateWithQueryParams(paginationBaseState, locationSearch)
  );
  const params = new URLSearchParams(locationSearch);
  const page = params.get('page');
  if (page) {
    sortedPaginationState.activePage = +page;
  }
  return sortedPaginationState;
};

/**
 * Parse the header link element and return all links inside.
 * Reimplemented locally: react-jhipster dropped this export in 1.0.0.
 *
 * @param header header of link
 */
export const parseHeaderForLinks = (header: string) => {
  if (header.length === 0) {
    throw new Error('input must not be of zero length');
  }
  // Split parts by comma
  const parts = header.split(',');
  const links: Record<string, number> = {};
  // Parse each part into a named link
  parts.forEach(p => {
    const section = p.split(';');
    if (section.length !== 2) {
      throw new Error('section could not be split on ";"');
    }
    const url = section[0].replace(/<(.*)>/, '$1').trim();
    const queryString: Record<string, string> = {};
    url.replace(/([^?=&]+)(=([^&]*))?/g, ($0, $1, $2, $3) => (queryString[$1] = $3));
    let page: number | string = queryString.page;
    if (typeof page === 'string') {
      page = parseInt(page, 10);
    }
    const name = section[1].replace(/rel="(.*)"/, '$1').trim();
    links[name] = page;
  });
  return links;
};
